import { config } from '@/api/front_config'

let conf = config["HOST_SETTINGS"]

export async function getPoints(token, regions){
    var result = await fetch(`${ conf["host_url"] }/map/points?` + 
    new URLSearchParams({"region": regions}), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })
    if(result.ok){
        result = await result.json()
        return result
    }
    return false
}

export async function getRegions(token){
    var result = await fetch(`${ conf["host_url"] }/map/all_regions`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
    if(result.ok){
        result = await result.json()
        return result
    }
    return false
}

export async function createPoint(token, form){
    const formData = new FormData(form)
    const entries = Object.fromEntries(formData)
    const params = {
        "name": entries.name,
        "region": entries.region,
        "district": entries.district,
        "type": entries.type,
        "av_order": entries.order,
        "status": entries.status,
        "pos": entries.precision,
        "notes": entries.description,
        "x": entries.x,
        "y": entries.y
      }
    const options = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify(params)
    }
    const data = await fetch(`${ conf["host_url"] }/map/create_point`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function movePoint(token, params){
    const options = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify(params)
    }
    const data = await fetch(`${ conf["host_url"] }/map/move_point`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function deletePoint(token, params){
    const options = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify(params)
    }
    const data = await fetch(`${ conf["host_url"] }/map/delete_point`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function getMemInfo(token, fid){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/point/${fid}`, options);
    if(data.ok){
        return await data.json();
    }
        return false;
}

export async function updatePoint(token, params){
    const options = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify(params)
    }
    const data = await fetch(`${ conf["host_url"] }/map/update_point`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function getMemText(token, fid){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/get_text/${fid}`, options);
    if(data.ok){
        return await data.json();
    }
        return false;
}

export async function updateText(token, params){
    const options = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': token,
    },
    body: JSON.stringify(params)
    }
    const data = await fetch(`${ conf["host_url"] }/map/update_text`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function getMemFiles(token, fid){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/get_files/${fid}`, options);
    if(data.ok){
        return await data.json();
    }
        return false;
}

export async function sendMemFile(token, params){
    const formData = new FormData()
    formData.append('fid', params.fid)
    formData.append('file', params.file)
    const options = {
    method: 'POST',
    headers: {
        'Authorization': token,
    },
    body: formData
    }
    const data = await fetch(`${ conf["host_url"] }/map/add_file`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function deleteMemFile(token, fileId){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/delete_file/${fileId}`, options);
    if(data.ok){
        return true;
    }
        return false;
}

export async function searchMemFiles(token, search_string){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/find_files/${search_string}`, options);
    if(data.ok){
        return await data.json();
    }
        return false;
}

export async function addFilesMem(token, files_list, fid){
        
        files_list.forEach(async(file) => {
                let options = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    },
                    body: JSON.stringify({"filename": file, "fid": fid})
                }
                let data = await fetch(`${ conf["host_url"] }/map/add_file_to_mem/`, options)
                if(!data.ok){
                    return false;
                }
                    
        })
        return true;
}

export async function showImage(filename){
    const options = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    }
    const data = await fetch(`${ conf["host_url"] }/map/show_image/${filename}`, options)
    if(data.ok){
        return data
    }
        return false
}